module.exports = __webpack_public_path__ + "images/components/estimate_banners/link_with_image/products_right_pc_84c82b7e3b9adc449ca9e09e7a06d768.svg";